import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { KendoModule } from "src/app/modules/kendo.module";
import { AuditDashboardComponent } from "../components/audit-dashboard/audit-dashboard.component";
import { StatePersistingService } from "../services/state-persisting-service";

@NgModule({ declarations: [
        AuditDashboardComponent
    ],
    exports: [
        AuditDashboardComponent
    ], imports: [BrowserModule,
        RouterModule,
        KendoModule], providers: [
        StatePersistingService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AuditModule { }